import translations from '../../../../static/locale/translations'

const LOCALES = {
    en: {
        name: 'English',
        currency: '$',
        code: 'en',
        rtl: false
    },
    el: {
        name: 'Greek',
        currency: '€',
        code: 'el',
        rtl: false
    },
    pt: {
        name: 'Portuguese',
        currency: '€',
        code: 'pt',
        rtl: false
    },
    es: {
        name: 'Spanish',
        currency: '€',
        code: 'es',
        rtl: false
    },
    tr: {
        name: 'Turkish',
        currency: '₺',
        code: 'tr',
        rtl: false
    }
}

export default {
    namespaced: true,
    state: () => ({
        locales: LOCALES,
        locale: LOCALES.en
    }),
    getters: {
        translate: (state, getters) => (key, ...replacements) => {
            const { code } = state.locale

            return getters.translationByLang(code, key, ...replacements)
        },
        translationByLang:
            () =>
            (code, key, ...replacements) => {
                if (!key) {
                    console.error(`No key for translation provided`)
                    return translations['na'][code]
                }

                // @ts-ignore
                const translationOptions = translations[key.toLowerCase()]
                if (!translationOptions) {
                    console.error(`Translation options for ${key} not found`)
                    return key
                }

                let translation = translationOptions[code]

                if (!translation) {
                    console.warn(`Translation to ${code} for ${key} not found`)
                    translation = translationOptions.en
                }

                if (translation && replacements.length) {
                    translation = translation.format(...replacements)
                }

                return translation || key
            },
        direction: state => (state.rtl ? 'rtl' : 'ltr')
    },
    mutations: {
        setLocale(state, key) {
            state.locale = state.locales[key]
        }
    },
    actions: {}
}
